module.exports = __webpack_public_path__ + "statics/img/6.2488059.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/6.png
// module id = wMz/
// module chunks = 1